import content, { format } from "../site/content";
import { useState } from 'react';
import videos from '../assets/videosStruct.json';
import { TextLines, PageTitle, Icon, Callout } from '../site/UI';
const labels = videos.map(video => video.tab_title);
const videoIcons = videos.map(video => video.icon);
const titles = videos.map(video => video.sous_tab[0].title);
const videoId = url => new URL(url).searchParams.get('v');
export default function PageNosVideos() {
  const [selected, setSelected] = useState(0);
  const [playing, setPlaying] = useState(false);
  const choose = i => {
    setSelected(i);
    setPlaying(false);
  };
  const id = videoId(videos[selected].sous_tab[0].video_url);
  return <div className="container section videos-page">
    <PageTitle title={content.pages.videos.meta.title} description={content.pages.videos.meta.description} />
    <header className="page-intro"><p className="eyebrow">{content.pages.videos.eyebrow}</p><h1><TextLines lines={content.pages.videos.title} /></h1><p className="lead">{content.pages.videos.intro}</p></header>
    <div className="video-tabs" role="tablist" aria-label={content.pages.videos.categories}>{labels.map((label, i) => <button id={'video-tab-' + i} key={label} role="tab" aria-selected={i === selected} aria-controls="video-panel" tabIndex={i === selected ? 0 : -1} onClick={() => choose(i)} onKeyDown={e => {
        if (['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(e.key)) {
          e.preventDefault();
          const next = e.key === 'Home' ? 0 : e.key === 'End' ? videos.length - 1 : (i + (e.key === 'ArrowRight' ? 1 : videos.length - 1)) % videos.length;
          choose(next);
          document.getElementById('video-tab-' + next)?.focus();
        }
      }}><Icon name={videoIcons[i]} />{label}</button>)}</div>
    <div id="video-panel" role="tabpanel" aria-labelledby={'video-tab-' + selected} className="video-feature">{playing ? <iframe key={id} src={'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1'} title={titles[selected]} allow="autoplay; encrypted-media; picture-in-picture; fullscreen" allowFullScreen /> : <button className="video-cover" onClick={() => setPlaying(true)} aria-label={format(content.pages.videos.play, {
        title: titles[selected]
      })}><img src={videos[selected].sous_tab[0].poster} alt="" /><span className="play-circle"><Icon name="play" /></span><span className="video-caption">{titles[selected]}</span></button>}</div>
    <h2 className="section-subtitle">{content.pages.videos.more}</h2><div className="video-grid">{labels.map((label, i) => i !== selected && <button className="video-cover" key={label} onClick={() => {
        choose(i);
        document.getElementById('video-tab-' + i)?.focus();
      }} aria-label={format(content.pages.videos.discover, {
        title: label
      })}><img loading="lazy" src={videos[i].sous_tab[0].poster} alt="" /><span className="play-circle"><Icon name="play" /></span><span className="video-caption">{label}</span></button>)}</div>
    <Callout title={content.pages.videos.callout.title} text={content.pages.videos.callout.text} to="/#nos-gites" label={content.pages.videos.callout.label} />
  </div>;
}
